import React, { useEffect, useMemo, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import http from "@shared/api/http";
import Loader from "@shared/components/Loader";
import CustomSelect from "@shared/components/CustomSelect";
import "./Preferences.css";
import { useTranslation } from "react-i18next";
import Alert from "react-bootstrap/Alert";
import DeleteAccount from "./DeleteAccount";

function checkPasswordPolicy(pw) {
  if (pw.length > 6) {
    return true;
  } else {
    return false;
  }
}

export default function Preferences() {
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [updateError, setUpdateError] = useState(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const url = useMemo(() => "/:locale/v2/:token/patient", []);

  const headers = {
    "Content-Type": "multipart-form-data",
    Accept: "application/json",
  };

  const [request, setRequest] = useState({
    loading: false,
    data: null,
    error: false,
  });
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const [language, setLanguage] = useState("de");
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    setLanguage(langCode);
  };

  const handleSubmit = (e) => {
    var params = new FormData();
    params.append("patient[name]", name);
    params.append("patient[language]", language);
    if (password != null) {
      if (checkPasswordPolicy(password)) {
        params.append("password", password);
      }
    }
    http
      .put(url + ".json", params)
      .then(function (response) {
        setUpdateSuccess(true);
      })
      .catch(function (error) {
        setUpdateError(true);
      });
    e.preventDefault();
  };

  let content = null;

  useEffect(() => {
    setRequest({
      loading: true,
      data: null,
      error: false,
    });
    http
      .get(url, { headers: headers })
      .then((response) => {
        setRequest({
          loading: false,
          data: response.data,
          error: false,
        });
        setName(response.data.name);
        setEmail(response.data.email);
        const lang = ["en", "it", "de"].includes(response.data.language)
          ? response.data.language
          : "de";
        setLanguage(lang);
      })
      .catch(() => {
        setRequest({
          loading: false,
          data: null,
          error: true,
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  if (request.error) {
    content = <div>Daten nicht gefunden. Bitte aktualisiere die Seite.</div>;
  }

  if (request.loading) {
    content = <Loader />;
  }

  if (request.data) {
    content = (
      <>
        <Container fluid className="h-100">
          <Row className="h-100 table-row">
            <Col md={3} className="table-column-title">
              Name
            </Col>
            <Col md={5}>
              <input
                type="text"
                name="name"
                className="profile-input-field"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="h-100 table-row">
            <Col md={3} className="table-column-title">
              E-Mail
            </Col>
            <Col md={5}>
              <input
                type="text"
                name="email"
                className="profile-input-field"
                readOnly
                value={email}
              />
            </Col>
          </Row>
          <Row className="h-100 table-row">
            <Col md={3} className="table-column-title">
              {t("password.change")}
            </Col>
            <Col md={5}>
              <input
                name="password"
                className="profile-input-field"
                type="password"
                value={password}
                placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                onChange={(e) => setPassword(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="h-100 table-row">
            <Col md={3} className="table-column-title">
              {t("language")}
            </Col>
            <Col md={5}>
              <CustomSelect
                value={language}
                onChange={handleLanguageChange}
                options={[
                  { value: "de", label: "German" },
                  { value: "en", label: "English" },
                  { value: "it", label: "Italian" },
                ]}
              />
            </Col>
          </Row>
          <Row className="h-100 table-row">
            <Col md={3} className="table-column-title">
              <Button
                type="submit"
                className="bs-button-color"
                onClick={(e) => {
                  handleSubmit(e);
                }}
              >
                {t("user.save")}
              </Button>
            </Col>
          </Row>
          <DeleteAccount />
        </Container>
        <Alert
          variant="success"
          className="alert-fixed"
          show={updateSuccess}
          onClose={() => setUpdateSuccess(false)}
          dismissible
        >
          <Alert.Heading>{t("user.update-success")}</Alert.Heading>
          <p>{t("user.data-updated")}</p>
        </Alert>
        <Alert
          variant="danger"
          className="alert-fixed"
          show={updateError}
          onClose={() => setUpdateError(false)}
          dismissible
        >
          <Alert.Heading>{t("user.update-error")}</Alert.Heading>
          <p>{t("user.try-again")}</p>
        </Alert>
      </>
    );
  }

  return <React.Fragment>{content}</React.Fragment>;
}
